export class CoverValueConverter {
	toView(value) {
		return value ? `background-image: url('${value.cover}')` : '';
	}
}
